// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchWrapper {
  width: 100%;
  position: relative;
  margin-right: auto;
  padding-left: 0;
  border-radius: 15px;
}

.searchWrapper .input-group {
  margin: 2px 0;
  background-color: #f7f7f7;
  border-radius: 5px;
  height: 35px;
}

.searchInput {
  color: #8a909d;
  background: transparent;
  padding: 0.5rem 15px;
  border: none;
}

.searchInput:focus {
  background: transparent;
}

.addedOrderTable {
  margin-top: 24px;
}

.noProductList,
.noCustomerList {
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.5s ease;
}

.productList,
.customerList {
  position: absolute;
  width: 91%;
  z-index: 9;
  background: white;
  opacity: 1;
  visibility: visible;
  /* transition: all 6s ease; */
  border: 1px solid #ced4da;
  border-radius: 5px;

  animation: slowMotion 10s ease infinite;

  @keyframes slowMotion {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
  
}

.selectedCustomer {
  border: none;
}

.productList ul#search-results,
.customerList ul#search-results {
  padding-top: 10px;
}

.customerList ul#search-results {
  height: 200px;
  overflow: auto;
}

.productList ul#search-results li,
.customerList ul#search-results li {
  padding: 5px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f3f3f3;
}

.productList ul#search-results li:last-child,
.customerList ul#search-results li:last-child {
  border-bottom: none;
}

#search-results li input {
  cursor: pointer;
}

#search-results li label {
  margin: 0 8px 8px 8px;
  cursor: pointer;
}

.closeIcon {
  cursor: pointer;
}

.productlistbutton {
  padding: 10px 15px 10px 15px;
}

.btn.btn-primary.cancelBtn {
  width: 15%;
  margin-right: 20px;
  background: #f3f3f3;
  border-color: #f3f3f3;
  color: #8a909d;
}

.addBtn {
  width: 15%;
}

.removeProduct {
  cursor: pointer;
}

.countWrapper {
  position: relative;
}

.minusCount,
.plusCount {
  position: absolute;
  cursor: pointer;
}

.minusCount span,
.plusCount span {
  position: relative;
  top: 9px;
}


.minusCount {
  left: -20px;
  width: 33px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
  margin: auto;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  background-color: #eeeeee;
}

.plusCount {
  /* right: 140px; */
  width: 33px;
  height: 40px;
  vertical-align: middle;
  text-align: center;
  margin: auto;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  background-color: #eeeeee;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.quantityInput {
  text-align: center;
  background-color: transparent;
  border: 1px solid #f3f3f3;
  width: 60%;
  height: 40px;
}

.createOrderPage .hasSelected {
  background-color: #f3f3f3;
  /*pointer-events: none;*/
}

.createOrderPage .hasNotId {
  pointer-events: none;
}

.addedItem {
  margin-left: 21px;
}

.productSearchWrapper #search-results {
  height: 250px;
  overflow: auto;
}

.addressList p {
  font-size: 14px;
  text-transform: capitalize;
}

.searchWrapper #search-btn.btn {
  /* color: var(--admin-color); */
  font-size: 18px;
}

.createOrderPage .checkBoxLabel {
  position: relative;
}

.createOrderPage #search-results input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;

}

.createOrderPage #search-results label:before {
  content: '';
  -webkit-appearance: none;
  border: 1px solid rgb(138, 144, 157);
  background-color: transparent;
  border-radius: 3px;
  padding: 7px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 12px;
}

.createOrderPage #search-results input:checked+label:after {
  content: '';
  display: block;
  position: absolute;
  top: 6px;
  left: 6px;
  width: 5px;
  height: 8px;
  border: solid blue;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.createOrderPage .isShippingAddress label {
  margin-bottom: 0;
  margin-left: 10px;
}

.createOrderPage .isShippingAddress input {
  vertical-align: unset;
}

.createOrderPage .billingAddress {
  cursor: pointer;
}

.createOrderPage .addressModal,
.createOrderPage .recipientModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  overflow: hidden;
  outline: 0;
  backdrop-filter: brightness(.5);
}

.recipientsUploads {
  top: 100px !important;
}

.createOrderPage .addressModalContent,
.createOrderPage .recipientModalContent {
  width: 600px;
  max-height: 95%;
  overflow: scroll;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9999999;
  transform: translate(-50%, -50%) !important;
  margin: 0 auto;
  background-color: white;
  padding: 30px;
  border-radius: var(--border-radius);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.createOrderPage .recipientModalContent {
  width: 1100px;
  padding: 0;
}

.recipientModalContentWrapper {
  width: 800px;
  padding: 0;
  margin: auto;
}

.createOrderPage .closeModal {
  cursor: pointer;
}

.createOrderPage .addRecipient {
  cursor: pointer;
  width: 30%;
}

.createOrderPage .bottomWrapper {
  position: relative;
}

.createOrderPage .recipientsCount {
  position: absolute;
  top: 25%;
  left: 0;
  right: 0;
}

.createOrderPage .lineItemImg {
  width: 10%;
}

.createOrderPage .lineItemImg img {
  width: 100%;
}

.createOrderPage .saveAddressBtn {
  cursor: pointer;
  position: relative;
  margin: 15px;
}

.createOrderPage .newRecipient {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 !important;
}

.createOrderPage .newRecipient td {
  padding: 10px 10px !important;
}

.createOrderPage .recipientWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  /* column-gap: 15px; */
  min-height: 80px;
  padding-bottom: 10px;
}

.createOrderPage .recipientWrapper span:nth-child(1) {
  flex: 0 0 80%;
  max-width: 80%;
}

.createOrderPage .recipientWrapper span:nth-child(2) {
  flex: 0 0 10%;
  max-width: 10%;
}

.createOrderPage .hideRecipientWrapper {
  display: none;
}

.createOrderPage .addedOrderTable td {
  vertical-align: top;
}

.createOrderPage .addedOrderTable .recipientTable td {
  vertical-align: unset;
  padding: 7px !important;
}

table.table tr td.addRecipient tr td.recipientWrapper,
table.table tr td.addRecipient tr {
  padding-top: 0 !important;
}

table.table tr td.personalization div {
  /* padding-top: 0 !important; */
}

.createOrderPage .personalization div {
  display: flex;
  min-height: 110px;
  padding-bottom: 18px;
}


.createOrderPage .messageBody {
  height: 50px;
  text-align: center;
  margin: auto;
}

.createOrderPage .messageBody p {
  position: relative;
  top: 50%;
  transform: translate(0px, -50%);
}

.createOrderPage .messageContent {
  width: 400px;
  padding: 20px;
}

.createOrderPage .messageBody p {
  color: #2DB744 !important;
}

.createOrderPage .closeRecipientModal {
  cursor: pointer
}

.createOrderPage .recipientModalHeader .alert {
  padding: 0;
}

.createOrderPage .addRecipientsItem {
  padding: 0 !important;
  color: rgb(138, 144, 157);
}

.createOrderPage .recipientTable {
  height: 300px;
  overflow: auto;
}

.createOrderPage .returnAddress,
.createOrderPage .billingAddress {
  cursor: pointer;
}

.createOrderPage .isShippingAddress input {
  height: auto;
}

.createOrderPage .addressCheckBox input {
  height: auto;
  margin-bottom: 0;
}

.display_error {
  display: block;
  position: absolute;
  left: 35%;
}

.hide_error {
  display: none;
}

.customerList .Searching {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
  height: 140px;
  
}

.customerLoader {
  height: 50px;
  position: absolute;
  right: 75%;
  top: -15px;
}

.payment_status {
  height: 42px;
}

.product_add_message {
  display: flex;
  justify-content: center;
  align-items: center;
}

.stock_display {
  display: flex;
  justify-content: center;
  align-items: center;
}

.out_of_stock {
  color: red;
}

.donation_box {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;

}

.donation_box input {
  width: 25%;
  margin-left: 2%;
  margin-bottom: 0;
}

.donation_checkbox {
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
}

.donation_checkbox input {
  margin-bottom: 0;
  margin-right: 10px;
}

.close_drop_down_button {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin: 5px;
  cursor: pointer;
}

.stock_zero {
  color: #E84A50;
}

.payment-btn-wrapper {
  display: flex;
  /* justify-content: end; */
  align-items: start;
}

.order_loader_top {
  height: 50px;
  position: absolute;
  right: 95%;
}

.order_loader_bottom {
  height: 50px;
  position: absolute;
  right: -20px;
}

.addressAndPersonalizationMessageWrapper{
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
}
.date_required .message{
  justify-content: start !important;
  text-wrap: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/OrdersForMultipleAddress/AddOrder/AddOrder.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;;EAElB,uCAAuC;;EAEvC;IACE;MACE,mBAAmB;IACrB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,mBAAmB;IACrB;EACF;;AAEF;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B","sourcesContent":[".searchWrapper {\n  width: 100%;\n  position: relative;\n  margin-right: auto;\n  padding-left: 0;\n  border-radius: 15px;\n}\n\n.searchWrapper .input-group {\n  margin: 2px 0;\n  background-color: #f7f7f7;\n  border-radius: 5px;\n  height: 35px;\n}\n\n.searchInput {\n  color: #8a909d;\n  background: transparent;\n  padding: 0.5rem 15px;\n  border: none;\n}\n\n.searchInput:focus {\n  background: transparent;\n}\n\n.addedOrderTable {\n  margin-top: 24px;\n}\n\n.noProductList,\n.noCustomerList {\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  transition: all 0.5s ease;\n}\n\n.productList,\n.customerList {\n  position: absolute;\n  width: 91%;\n  z-index: 9;\n  background: white;\n  opacity: 1;\n  visibility: visible;\n  /* transition: all 6s ease; */\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n\n  animation: slowMotion 10s ease infinite;\n\n  @keyframes slowMotion {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.05);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  \n}\n\n.selectedCustomer {\n  border: none;\n}\n\n.productList ul#search-results,\n.customerList ul#search-results {\n  padding-top: 10px;\n}\n\n.customerList ul#search-results {\n  height: 200px;\n  overflow: auto;\n}\n\n.productList ul#search-results li,\n.customerList ul#search-results li {\n  padding: 5px 15px;\n  cursor: pointer;\n  border-bottom: 1px solid #f3f3f3;\n}\n\n.productList ul#search-results li:last-child,\n.customerList ul#search-results li:last-child {\n  border-bottom: none;\n}\n\n#search-results li input {\n  cursor: pointer;\n}\n\n#search-results li label {\n  margin: 0 8px 8px 8px;\n  cursor: pointer;\n}\n\n.closeIcon {\n  cursor: pointer;\n}\n\n.productlistbutton {\n  padding: 10px 15px 10px 15px;\n}\n\n.btn.btn-primary.cancelBtn {\n  width: 15%;\n  margin-right: 20px;\n  background: #f3f3f3;\n  border-color: #f3f3f3;\n  color: #8a909d;\n}\n\n.addBtn {\n  width: 15%;\n}\n\n.removeProduct {\n  cursor: pointer;\n}\n\n.countWrapper {\n  position: relative;\n}\n\n.minusCount,\n.plusCount {\n  position: absolute;\n  cursor: pointer;\n}\n\n.minusCount span,\n.plusCount span {\n  position: relative;\n  top: 9px;\n}\n\n\n.minusCount {\n  left: -20px;\n  width: 33px;\n  height: 40px;\n  vertical-align: middle;\n  text-align: center;\n  margin: auto;\n  border: 1px solid #eeeeee;\n  border-radius: 3px;\n  background-color: #eeeeee;\n}\n\n.plusCount {\n  /* right: 140px; */\n  width: 33px;\n  height: 40px;\n  vertical-align: middle;\n  text-align: center;\n  margin: auto;\n  border: 1px solid #eeeeee;\n  border-radius: 3px;\n  background-color: #eeeeee;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.quantityInput {\n  text-align: center;\n  background-color: transparent;\n  border: 1px solid #f3f3f3;\n  width: 60%;\n  height: 40px;\n}\n\n.createOrderPage .hasSelected {\n  background-color: #f3f3f3;\n  /*pointer-events: none;*/\n}\n\n.createOrderPage .hasNotId {\n  pointer-events: none;\n}\n\n.addedItem {\n  margin-left: 21px;\n}\n\n.productSearchWrapper #search-results {\n  height: 250px;\n  overflow: auto;\n}\n\n.addressList p {\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.searchWrapper #search-btn.btn {\n  /* color: var(--admin-color); */\n  font-size: 18px;\n}\n\n.createOrderPage .checkBoxLabel {\n  position: relative;\n}\n\n.createOrderPage #search-results input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n\n}\n\n.createOrderPage #search-results label:before {\n  content: '';\n  -webkit-appearance: none;\n  border: 1px solid rgb(138, 144, 157);\n  background-color: transparent;\n  border-radius: 3px;\n  padding: 7px;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  margin-right: 12px;\n}\n\n.createOrderPage #search-results input:checked+label:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  width: 5px;\n  height: 8px;\n  border: solid blue;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.createOrderPage .isShippingAddress label {\n  margin-bottom: 0;\n  margin-left: 10px;\n}\n\n.createOrderPage .isShippingAddress input {\n  vertical-align: unset;\n}\n\n.createOrderPage .billingAddress {\n  cursor: pointer;\n}\n\n.createOrderPage .addressModal,\n.createOrderPage .recipientModal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999999;\n  overflow: hidden;\n  outline: 0;\n  backdrop-filter: brightness(.5);\n}\n\n.recipientsUploads {\n  top: 100px !important;\n}\n\n.createOrderPage .addressModalContent,\n.createOrderPage .recipientModalContent {\n  width: 600px;\n  max-height: 95%;\n  overflow: scroll;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 9999999;\n  transform: translate(-50%, -50%) !important;\n  margin: 0 auto;\n  background-color: white;\n  padding: 30px;\n  border-radius: var(--border-radius);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n\n.createOrderPage .recipientModalContent {\n  width: 1100px;\n  padding: 0;\n}\n\n.recipientModalContentWrapper {\n  width: 800px;\n  padding: 0;\n  margin: auto;\n}\n\n.createOrderPage .closeModal {\n  cursor: pointer;\n}\n\n.createOrderPage .addRecipient {\n  cursor: pointer;\n  width: 30%;\n}\n\n.createOrderPage .bottomWrapper {\n  position: relative;\n}\n\n.createOrderPage .recipientsCount {\n  position: absolute;\n  top: 25%;\n  left: 0;\n  right: 0;\n}\n\n.createOrderPage .lineItemImg {\n  width: 10%;\n}\n\n.createOrderPage .lineItemImg img {\n  width: 100%;\n}\n\n.createOrderPage .saveAddressBtn {\n  cursor: pointer;\n  position: relative;\n  margin: 15px;\n}\n\n.createOrderPage .newRecipient {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  padding: 0 !important;\n}\n\n.createOrderPage .newRecipient td {\n  padding: 10px 10px !important;\n}\n\n.createOrderPage .recipientWrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  /* justify-content: space-between; */\n  /* column-gap: 15px; */\n  min-height: 80px;\n  padding-bottom: 10px;\n}\n\n.createOrderPage .recipientWrapper span:nth-child(1) {\n  flex: 0 0 80%;\n  max-width: 80%;\n}\n\n.createOrderPage .recipientWrapper span:nth-child(2) {\n  flex: 0 0 10%;\n  max-width: 10%;\n}\n\n.createOrderPage .hideRecipientWrapper {\n  display: none;\n}\n\n.createOrderPage .addedOrderTable td {\n  vertical-align: top;\n}\n\n.createOrderPage .addedOrderTable .recipientTable td {\n  vertical-align: unset;\n  padding: 7px !important;\n}\n\ntable.table tr td.addRecipient tr td.recipientWrapper,\ntable.table tr td.addRecipient tr {\n  padding-top: 0 !important;\n}\n\ntable.table tr td.personalization div {\n  /* padding-top: 0 !important; */\n}\n\n.createOrderPage .personalization div {\n  display: flex;\n  min-height: 110px;\n  padding-bottom: 18px;\n}\n\n\n.createOrderPage .messageBody {\n  height: 50px;\n  text-align: center;\n  margin: auto;\n}\n\n.createOrderPage .messageBody p {\n  position: relative;\n  top: 50%;\n  transform: translate(0px, -50%);\n}\n\n.createOrderPage .messageContent {\n  width: 400px;\n  padding: 20px;\n}\n\n.createOrderPage .messageBody p {\n  color: #2DB744 !important;\n}\n\n.createOrderPage .closeRecipientModal {\n  cursor: pointer\n}\n\n.createOrderPage .recipientModalHeader .alert {\n  padding: 0;\n}\n\n.createOrderPage .addRecipientsItem {\n  padding: 0 !important;\n  color: rgb(138, 144, 157);\n}\n\n.createOrderPage .recipientTable {\n  height: 300px;\n  overflow: auto;\n}\n\n.createOrderPage .returnAddress,\n.createOrderPage .billingAddress {\n  cursor: pointer;\n}\n\n.createOrderPage .isShippingAddress input {\n  height: auto;\n}\n\n.createOrderPage .addressCheckBox input {\n  height: auto;\n  margin-bottom: 0;\n}\n\n.display_error {\n  display: block;\n  position: absolute;\n  left: 35%;\n}\n\n.hide_error {\n  display: none;\n}\n\n.customerList .Searching {\n  text-align: center;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  height: 140px;\n  \n}\n\n.customerLoader {\n  height: 50px;\n  position: absolute;\n  right: 75%;\n  top: -15px;\n}\n\n.payment_status {\n  height: 42px;\n}\n\n.product_add_message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.stock_display {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.out_of_stock {\n  color: red;\n}\n\n.donation_box {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n\n}\n\n.donation_box input {\n  width: 25%;\n  margin-left: 2%;\n  margin-bottom: 0;\n}\n\n.donation_checkbox {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.donation_checkbox input {\n  margin-bottom: 0;\n  margin-right: 10px;\n}\n\n.close_drop_down_button {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.stock_zero {\n  color: #E84A50;\n}\n\n.payment-btn-wrapper {\n  display: flex;\n  /* justify-content: end; */\n  align-items: start;\n}\n\n.order_loader_top {\n  height: 50px;\n  position: absolute;\n  right: 95%;\n}\n\n.order_loader_bottom {\n  height: 50px;\n  position: absolute;\n  right: -20px;\n}\n\n.addressAndPersonalizationMessageWrapper{\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  justify-content: flex-start;\n}\n.date_required .message{\n  justify-content: start !important;\n  text-wrap: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
